import { graphqlBaseApi } from './graphqlBaseApi';

// TODO: Generate typings from SDL
interface ISitecoreGraphResponse {
  data?: any;
  errors?: any;
  search?: any;
}

const CACHE_TAG = 'sc_content_item';

export const contentApi = graphqlBaseApi.enhanceEndpoints({ addTagTypes: [CACHE_TAG] }).injectEndpoints({
  endpoints: (builder) => ({
    getItems: builder.query<ISitecoreGraphResponse, any>({
      query: ({ document, variables }) => ({
        document,
        variables
      }),
      providesTags: () => [CACHE_TAG]
    })
  })
});

export const { useGetItemsQuery, useLazyGetItemsQuery } = contentApi;
